import React, { useEffect, useState } from "react";
import api, { fileUrl , formatTanggal} from "@/lib/api";
import Layout, { PageTitle } from "@/components/Layout";
import { NAV_ORTU } from "@/lib/nav";
import { useAuth } from "@/context/AuthContext";
import { IdCard } from "lucide-react";
import KartuPelajarModal from "@/components/KartuPelajarModal";

export function ProfilSiswaOrtu() {
  const { user } = useAuth();
  const [siswa, setSiswa] = useState(null);
  const [pend, setPend] = useState(null);
  const [epList, setEpList] = useState([]);
  const [showKartu, setShowKartu] = useState(false);
  useEffect(() => {
    (async () => {
      try {
        const { data: s } = await api.get(`/siswa/${user.linked_id}`);
        const { data: p } = await api.get("/pendampingan");
        const { data: ep } = await api.get("/ekskul-progsus/pendampingan");
        setSiswa(s); setPend(p[0] || null);
        setEpList(ep);
      } catch (e) { console.error(e); }
    })();
  }, [user]);
  if (!siswa) return <Layout nav={NAV_ORTU}><PageTitle title="Profil Siswa" /><div className="pp-card p-12 text-center text-slate-400 italic">Memuat…</div></Layout>;
  return (
    <Layout nav={NAV_ORTU}>
      <PageTitle title="Profil Siswa" />
      <section className="pp-card p-6 sm:p-8">
        <div className="flex flex-col sm:flex-row gap-6 mb-6">
          {siswa.foto_file_id ? <img src={fileUrl(siswa.foto_file_id)} className="w-36 h-36 rounded-xl object-cover border border-slate-200" alt="" />
            : <div className="w-36 h-36 rounded-xl bg-slate-100 flex items-center justify-center text-slate-300 text-5xl font-bold">{siswa.nama[0]}</div>}
          <div className="flex-1">
            <h3 className="text-2xl font-bold">{siswa.nama}</h3>
            <p className="text-slate-500 font-mono text-sm">NISN: {siswa.nis}</p>
            <div className="mt-2 flex items-center gap-2 flex-wrap">
              <span className={siswa.status === "aktif" ? "pp-badge-success" : "pp-badge-danger"}>{siswa.status}</span>
              <button onClick={() => setShowKartu(true)} className="pp-btn-primary text-xs" data-testid="ortu-open-kartu">
                <IdCard className="w-3.5 h-3.5" /> Lihat Kartu Pelajar
              </button>
            </div>
          </div>
        </div>
        <dl className="grid sm:grid-cols-2 gap-x-6 gap-y-3 text-sm pt-6 border-t border-slate-100">
          {[
            ["Tempat/Tgl Lahir", `${siswa.tempat_lahir || "—"}, ${formatTanggal(siswa.tanggal_lahir)}`],
            ["Jenis Kelamin", siswa.jenis_kelamin === "L" ? "Laki-laki" : "Perempuan"],
            ["Alamat", siswa.alamat || "—"],
            ["Nama Ayah", siswa.nama_ayah || "—"], ["Pekerjaan Ayah", siswa.pekerjaan_ayah || "—"], ["Telp Ayah", siswa.telp_ayah || "—"],
            ["Nama Ibu", siswa.nama_ibu || "—"], ["Pekerjaan Ibu", siswa.pekerjaan_ibu || "—"], ["Telp Ibu", siswa.telp_ibu || "—"],
            ["Guru Pendamping", pend?.nama_guru || "Belum ditentukan"],
            ["Kelas / Ruangan", pend ? `${pend.kelas || "—"} — ${pend.ruangan || "—"}` : "—"],
            ["Ketunaan", siswa.ketunaan || "—"],
            ["Fase", pend?.fase || "—"],
          ].map(([k, v]) => (<div key={k}><dt className="text-xs uppercase text-slate-500">{k}</dt><dd className="text-slate-900 mt-0.5">{v}</dd></div>))}
        </dl>
        <div className="pt-6 mt-6 border-t border-slate-100">
          <div className="text-xs uppercase text-slate-500 mb-2">Ekskul & Progsus yang Diikuti</div>
          {epList.length === 0 ? (
            <div className="text-sm text-slate-400 italic">Belum ada ekskul / progsus yang diikuti.</div>
          ) : (
            <ul className="grid sm:grid-cols-2 gap-2" data-testid="ortu-ep-list">
              {epList.map((it) => (
                <li key={it.id} className="flex items-start gap-2 text-sm">
                  <span className="mt-1 w-1.5 h-1.5 rounded-full bg-indigo-500 shrink-0" />
                  <div>
                    <div className="text-slate-900 font-medium">{it.jenis}</div>
                    <div className="text-xs text-slate-500">Pendamping: {it.nama_guru || "—"}</div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </section>
      {showKartu && <KartuPelajarModal siswa={siswa} onClose={() => setShowKartu(false)} />}
    </Layout>
  );
}
